import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { cartConstants } from 'services/redux/cart/constants'
import _ from 'lodash'
import i18n from 'utils/i18n'
import HelperCart from 'utils/helper-cart'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import ThemedLayout from 'components/atoms/ThemedLayout'
import { dataConstants } from 'services/redux/data/constants'
import RenderEmployeeList from '../_functions/EmployeeRenders'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation, useRoute } from '@react-navigation/native'
import EmployeeFooter from 'scenes/home/book/_components/EmployeeFooter'
import Translate from 'utils/translate'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'
import TextDivider from 'components/atoms/TextDivider'
import EmployeeStatusTag from 'scenes/home/book/validate/_components/EmployeeStatusTag'
import ThemedHint from 'components/molecules/ThemedHint'
import ValidateBookingFunctions from 'scenes/home/book/validate/_functions/ValidateBookingFunctions'
import { setEmployeeStatus } from 'services/redux/cart/actions'
import { timeslotGroupForTitle } from 'scenes/home/book/coworker/_functions/TimeslotGroupFunctions'
import selectTimeslotGroup from 'services/redux/data/selectors/selectTimeslotGroup'
import useRouteParameters from 'utils/hooks/use-route-parameters'
import HelperPlatform from 'utils/helper-platform'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'
import { layoutStyles } from "styles/layout";

const HomeBookSelectCoworkerViewScene = () => {
	
	const navigation = useNavigation();
	const route = useRoute();
	const dispatch = useDispatch();
	const _routeParameters = useRouteParameters( route );
	
	const [ footerHeight, setFooterHeight ] = useState( 0 )
	
	const _bookingExternalPersons = useSelector( state => {
		return state.cart[cartConstants.BOOKING_EXTERNAL_PERSONS];
	} );
	const _cartBookingCoworkers = useSelector( state => {
		return state.cart[cartConstants.BOOKING_COWORKERS];
	} );
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const _timeslotGroup = useSelector( state => {
		return selectTimeslotGroup(state, _.get(_routeParameters, routeBookingConstants.TIMESLOT_GROUP));
	} ); // do not remove, required for reloading
	const _bookForOption = _.get( _routeParameters, routeBookingConstants.FOR_OPTION );
	const _employeeStatus = useSelector( state => {
		return state.cart[cartConstants.EMPLOYEE_STATUS];
	} );
	
	const onSetEmployeeStatus = ( employee ) => {
		dispatch( setEmployeeStatus( ValidateBookingFunctions.updateEmployeeStatus( _employeeStatus, employee ) ) );
	}
	
	const employeeLists = [];
	if( !HelperCart.bookingForOthers() ){
		let employees = {};
		employees[ _employee.guid ] = {
			..._employee,
			readOnly: true
		};
		
		employeeLists.push(
			<RenderEmployeeList
				containerStyle={ layoutStyles.flexUnset }
				employees={ employees }
				showSelf={ true }
			/>
		);
	}
	
	employeeLists.push(
		<ThemedHint hint={ i18n.t( 'hints.booking_invite_click_employee_to_accept' ) } />
	);
	
	if ( _.size( _cartBookingCoworkers ) > 0 ) {
		
		let employees = {};
		_.forEach( _cartBookingCoworkers, ( employee ) => {
			employees[ employee.guid ] = {
				...employee,
				deletable: true
			};
		});
		
		employeeLists.push(
			<VStack space={ 0 }>
				<TextDivider key={ 'coworkers' }  text={ i18n.t( 'page.create.coworker.mode_co_workers') } />
				
				<RenderEmployeeList
					containerStyle={ layoutStyles.flexUnset }
					employees={ employees }
					onPressEmployee={ onSetEmployeeStatus.bind( this ) }
					show={ employee => {
						return (
							<EmployeeStatusTag
								employee={ employee }
								employeeStatus={ _employeeStatus }
							/>
						);
					}}
				/>
			</VStack>
		);
	}
	
	if ( _.size( _bookingExternalPersons ) > 0 ) {
		
		let employees = {};
		_.forEach( _bookingExternalPersons, ( employee ) => {
			employees[ employee.guid ] = {
				...employee,
				deletable: true
			};
		});
		
		employeeLists.push(
			<VStack space={ 0 }>
				<TextDivider key={ 'external_relations' }  text={ i18n.t( 'page.create.coworker.mode_external') } />
				
				<RenderEmployeeList
					containerStyle={ layoutStyles.flexUnset }
					employees={ employees }
					onPressEmployee={ onSetEmployeeStatus.bind( this ) }
					show={ employee => {
						return (
							<EmployeeStatusTag
								employee={ employee }
								employeeStatus={ _employeeStatus }
							/>
						);
					}}
				/>
			</VStack>
		);
	}
	const save = () => {
		navigation.navigate( AppRoutes.ADD_BOOKING_LOCATION,
			_routeParameters
		);
	}
	
	const title = Translate.field( _timeslotGroup, 'title' );
	const subtitle = timeslotGroupForTitle( _bookForOption, _timeslotGroup );
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				contentWidth="narrow"
				title={ title }
				subtitle={ subtitle }
				showBackButton={ true }
				topNavigation={ true }
				style={ {
					paddingBottom: footerHeight + 10
				} }>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					{ employeeLists }
				</VStack>
			</ThemedLayout>
			
			<EmployeeFooter
				onHeight={ setFooterHeight }
				showEmployees={ false }
				onPressSubmit={ save }
				submitLabel={ i18n.t( 'page.create.coworker.create_booking' ) }
			/>
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeBookSelectCoworkerViewScene;
